import { NFeEntradaItemLoteStruct } from '../../structs/repo-dfe/nfe-entrada-item-lote.struct';
import { RegraCorrespondenciaProdutoNFeEntradaEnum } from '../../../enums/suprimentos/regra-correspondencia-produto-nfe-entrada.enum';
import { EstadoAssociacaoItemNFeEntradaEnum } from '../../../enums/suprimentos/estado-associacao-item-nfe-entrada.enum';

/** Estado completo da associação de um item alterado no modal; espelha o request da API.RepoDFe. */
export class NFeEntradaAssociacaoItemRequest {
  idNFeEntradaItem: number;
  /** Produto escolhido; nulo só com isProdutoRemovido ou em item que já estava sem produto. */
  idProduto: number | null = null;
  /** Desfaz o vínculo de forma explícita; nulo em idProduto não remove o vínculo por si só. */
  isProdutoRemovido = false;
  idRegraCorrespondenciaProdutoNFeEntrada: RegraCorrespondenciaProdutoNFeEntradaEnum;
  idEstadoAssociacaoItemNFeEntrada: EstadoAssociacaoItemNFeEntradaEnum;
  /** Fator digitado, confirmado ou não (isFatorConversaoConfirmado). */
  fatorConversao: number | null = null;
  isFatorConversaoConfirmado = false;
  isLotesNaUnidadeComercial = false;
  datetimeAlteracao: Date | null = null;
  lotes: NFeEntradaItemLoteStruct[] = [];
  numerosSerie: string[] = [];
}
